// @import types
import { IUserCertification } from 'app_types/campus/user/userInfoTypes'
import { IHttpResponse } from 'app_types/httpTypes'
import { ICertificateSettings } from '../certificateSettings/certificateSettings.types';
import { ICourseSchedulingListItem } from './courseSchedulingTypes';
// @end

// @add your types
export enum CertificateQueueStatus {
  NEW = 'New',
  IN_PROCESS = 'In-process',
  REQUESTED = 'Requested',
  COMPLETE = 'Complete',
  ERROR = 'Error',
  RE_ISSUE = 'Re-issue'
}

export enum EnrollmentStatus {
  REGISTERED = 'registered',
  IN_PROGRESS = 'in-progress',
  COMPLETED = 'completed',
  CERTIFIED = 'certified',
}

export enum EnrollmentOrigin {
  AUTOREGISTRO = 'autoregistro'
}

export const CERTIFICATE_QUEUE_STATUS_NAME = {
  [CertificateQueueStatus.NEW]: 'Procesando',
  [CertificateQueueStatus.IN_PROCESS]: 'Procesando',
  [CertificateQueueStatus.REQUESTED]: 'Procesando',
  [CertificateQueueStatus.COMPLETE]: 'Generado',
  [CertificateQueueStatus.ERROR]: 'Error',
  [CertificateQueueStatus.RE_ISSUE]: 'Procesando',
}

export interface INewCourseSchedulingEnrollment {
  user?: {
    _id: string
    profile: {
      first_name: string,
      last_name: string
      full_name: string,
      doc_number: string
    },
    email: string,
  }
  courseID: string
  _id?: string
}

export type CertificateStatus = 'New' | 'In-process' | 'Requested' | 'Complete' | 'Error' | 'Re-issue'

export interface ICertificationsStage {
  certificationQueueId: string,
  certificationCode: string,
  certificationStatus: CertificateStatus
  userDocNumber: string,
  userFullName: string,
  certificationType: string,
  certificateConsecutive: string
}

export enum CertificateCategory {
  FORCE_PREVIEW = 'force_preview',
  FORCE_PROCESS = 'force_process'
}
export interface ICertificateStage {
  status: boolean,
  certifications?: ICertificationsStage[],
  title?: string,
  message?: string
  notes?: string,
  category?: CertificateCategory
}

export interface ICertificate {
  certificateConsecutive: string,
  certificateModule: string
  certificateSetting?: string,
  certificateType: string
  courseId: string
  status: CertificateStatus
  userId: string
  certificate: {
    hash: string,
    url: string,
    imagePath?: string;
    pdfPath?: string;
  },
  errorMessage?: string
  _id: string
}

export interface ICourseSchedulingEnrollmentListItem extends INewCourseSchedulingEnrollment {
  _id?: string
  certificate?: ICertificate[],
  enrollmentCode: string,
  progress?: {
    status?: string,
    attended_approved?: string,
    average_grade?: number,
    completion?: number,
    assistance?: number,
    quizGrade?: number,
    auditorCertificate?: string,
    auditorGradeC1?: number,
    auditorGradeC2?: number,
  }
  certificates?: ICertification[]
  firstname?: string
  lastname?: string
  course_scheduling_doc?: Partial<ICourseSchedulingListItem>
}

export interface ICourseSchedulingEnrollmentsHttpResponse extends IHttpResponse {
  isAuditorCerficateEnabled: boolean,
  firstCertificateIsAuditor: boolean,
  previewCertificateParams: any,
  schedulingMode: string,
  enrollment: ICourseSchedulingEnrollmentListItem[]
  total_register: number
  pageNumber: number
  nPerPage: number
}

export interface ICourseSchedulingEnrollmentHttpResponse extends IHttpResponse {
  enrollment: INewCourseSchedulingEnrollment
  total_register: number
  pageNumber: number
  nPerPage: number
}

export interface ICertification {
  _id: string,
  userId: string,
  courseId: string,
  certificateType: string,
  certificateModule: string,
  status: string
  message: string
  certificateSetting?: Partial<ICertificateSettings>
}
export interface IGenerateCertifications extends IHttpResponse {
  certificateQueue: ICertification[]
}

export interface ICertificationItem {
  userId: {
    fullname: string,
    profile: {
      doc_number: string,
    },
  },
  courseId: {
    program: {
      _id: string;
      name: string,
    },
  },
  status: string
  date: string,
  certificate: IUserCertification
  _id: string
}
export interface IFetchCertificationsDataHttpResponse extends IHttpResponse {
  certifications: ICertificationItem[]
  total_register: number
  pageNumber: number
  nPerPage: number
}

export interface IDownloadMasiveCertificationsHttpResponse extends IHttpResponse {
  path: string
}

export interface ICertificationForceLog {
  key: string,
  message: string,
  status: 'success' | 'error'
}
export interface ICertificationForceHttpResponse extends IHttpResponse {
  certificateLogs?: ICertificationForceLog[]
}

export interface IEnrollmentInsertOrUpdateParams {
  _id?: string
  user: string
  email: string
  password?: string
  firstname: string
  lastname: string
  documentType: string
  documentID: string
  courseID: string
  origin?: string
  sendEmail?: boolean
}
//@end
